import { useState } from 'react';
import { Icon } from './Icon';
import { themeColors } from '../theme/theme'; // Adjust the import based on your project structure
import { useTranslation } from '@/kit/useTranslation';

export function SearchBar({ onSearch }) {
  const { t } = useTranslation();
  const [value, setValue] = useState('');
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSearch(value);
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        background: themeColors.backgroundColor,
        borderRadius: 24,
        boxShadow: '0 2px 8px #0001',
        padding: '0.5em 1em',
        margin: '0 0',
        width: '100%',
      }}
    >
      <Icon name="search" size="medium" style={{ marginRight: 8, color: '#888' }} />
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={t('common.searchPlaceholder')}
        style={{
          border: 'none',
          outline: 'none',
          fontSize: '1em',
          flex: 1,
          background: 'transparent',
          color: themeColors.textColor,
        }}
      />
      <button type="submit" style={{ display: 'none' }}>
        Search
      </button>
    </form>
  );
}
